<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
    append-to-body
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button :disabled="confirmVisible" type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { settingApi, importApi, thirdApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
import moment from 'moment';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      exportData: [], // 存放上传的excel文件的数据
      confirmVisible: false,
      channelData: this.$store.getters.storePriceControl
    };
  },
  methods: {
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      importApi.getImportTemplateHeaders({
        templateCode: 'STHI.THIRD_GOODS_IMPORT',
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            downloadBlob(resp, res.content[0].templateFileName);
          });
      });
    },
    importFile(file) {
      this.exportData = [];
      this.confirmVisible = false;
      let errorMsg = '';
      const _this = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function () {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
        });
        const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        for (const v of Object.values(outData)) {
                const obj = {
                  'innerSkuCode': v['SKU'],
                  'skuCode': v['platform SKU'],
                  'price': v['price(active now)'],
                  'newPrice': v['price(active future with active time)'],
                  'updatePriceTime': v['active time(dd/mm/yyyy)'],
                };
                _this.exportData.push(obj);
            }
        // 数据的非空校验
        for (const item of Object.values(_this.exportData)) {
          if (!item.innerSkuCode || !item.skuCode) return _this.$message.error(_this.$t('ChannelManagement.Main.fileErrorMsg1'));
          if (!item.price) {
            if (!item.newPrice || !item.updatePriceTime) {
              _this.confirmVisible = true;
              _this.$message.error(_this.$t('ChannelManagement.Main.errorMsg2'));
              return;
            }
          }
          if (item.newPrice) {
            if (!item.updatePriceTime) {
              _this.confirmVisible = true;
              _this.$message.error(_this.$t('ChannelManagement.Main.errorMsg3'));
              return;
            }
          }
          if (item.updatePriceTime) {
            if (!item.newPrice) {
              _this.confirmVisible = true;
              _this.$message.error(_this.$t('ChannelManagement.Main.errorMsg3'));
              return;
            }
          }
          if (!item.price && !item.newPrice && !item.updatePriceTime) {
            _this.confirmVisible = true;
            _this.$message.error(_this.$t('ChannelManagement.Main.fileErrorMsg1'));
            return;
          }
        }

        // SKU编码 去重
        const innerSkuCodeArray = [...new Set(_this.exportData.map(item => item.innerSkuCode))].filter(item => _this.exportData.filter(obj => obj.innerSkuCode === item).length > 1);
        //  平台SKU编码 去重
        const skuCodeArray = [...new Set(_this.exportData.map(item => item.skuCode))].filter(item => _this.exportData.filter(obj => obj.skuCode === item).length > 1);

        if (innerSkuCodeArray.length) {
            _this.confirmVisible = true;
            innerSkuCodeArray.forEach(item => (errorMsg += `${item}, `));
        }
        if (skuCodeArray.length) {
            _this.confirmVisible = true;
            skuCodeArray.forEach(item => (errorMsg += `${item}, `));
        }
        if (_this.confirmVisible) {
           errorMsg += _this.$t('ChannelManagement.Main.fileErrorMsg2');
           return _this.$message({ message: errorMsg, type: 'error', duration: 10000, showClose: true });
        }
      };
    },
    confirm() {
      if (this.exportData.length && !this.confirmVisible) {
        const skuCodeList = this.exportData.map(item => (item.skuCode));
        thirdApi.verifyThirdPartyGoodsSku(skuCodeList).then(res => {
          if (res.length) {
            let errorMsg = '';
            res.forEach(item => (errorMsg += `${item}, `));
            errorMsg += this.$t('ChannelManagement.Main.fileErrorMsg3');
            this.confirmVisible = true;
            return this.$message({ message: errorMsg, type: 'error', duration: 10000, showClose: true });
          } else {
            this.exportData.forEach(item => {
                item['channelCode'] = this.channelData.channelTypeCode;
                item['storeId'] = this.channelData.id;
                item['storeCode'] = this.channelData.code;
                item['storeName'] = this.channelData.channelWarehouseName;
                item['channelName'] = this.channelData.channelTypeMeaning;
                item['status'] = 1;
                item['updatePriceTime'] = moment(item.updatePriceTime, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm:ss');
            });
          }
          thirdApi.addThirdPartyGoods(this.exportData).then(res => {
           if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
             setTimeout(() => {
                 this.hide();
                 this.$emit('reFresh');
               }, 500);
           }
          });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
